import React from 'react';
import './SeverityLevel.scss';

export const SeverityLevelEnum = Object.freeze({
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    NONE: 'NONE'
});

const getSeverityLevelClassName = level => {
    switch (level) {
        case SeverityLevelEnum.LOW:
            return 'low';
        case SeverityLevelEnum.MEDIUM:
            return 'medium';
        case SeverityLevelEnum.HIGH:
            return 'high';
        case SeverityLevelEnum.NONE:
        default:
            return 'none';
    }
};

export const SeverityLevel = ({ text, level }) => (
    <span className={'severity-level ' + getSeverityLevelClassName(level)}>
        {text}
    </span>
);
